import React, {useEffect} from 'react';
import Our_program_content from '../Component/Our_program_content'

function Our_program() {
    useEffect(()=>{
        document.title='Traineeship Program | InternsElite';
      },[]);
  return (
    <div>

    {/* --------------------------Mobile View-------------------------   */}
    <div className='Mobile_Our_program_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid Mobile_background_color pt-4'>
            <div className='text-center Mobile_Main_text py-5'>
                <h1 className='display-4 text-white'>Traineeship Program</h1>
                <h3 className='text-white fs-6 pt-2'>Immerse in real-world challenges, gaining practical insights and honing your skills for a dynamic career journey.</h3>
            </div>
        </div>
    </div>

    {/* --------------------------Desktop View--------------------------- */}
    <div className='Our_program_image d-none d-md-block mt-5'>
        <div className='container-fluid Our_program_background_color pt-5'>
            <div className='text-center pt-5 Our_program_Main_text'>
                <h1 className='display-4 mt-5 pt-5 text-white'>Traineeship Program</h1>
                <h3 className='text-white fs-4 pt-4 '>Immerse in real-world challenges, gaining practical insights and honing your skills for a dynamic career journey.</h3>
            </div>
        </div>
    </div>
    <Our_program_content/>
    </div>
  )
}

export default Our_program
